import { atom, useAtom } from 'jotai';
import { Evaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';

type EvaluationHistory = { [key: string]: Array<Evaluation> };

const futureEvaluationAtom = atom<EvaluationHistory>({});
const pastEvaluationAtom = atom<EvaluationHistory>({});

const MAX_HISTORY_SIZE = 10;

export function useEvaluationHistory(evaluationId: string) {
  const [past, setPast] = useAtom(pastEvaluationAtom);
  const [future, setFuture] = useAtom(futureEvaluationAtom);

  return {
    past: past[evaluationId] || [],
    resetFuture: () => {
      setFuture({ ...future, [evaluationId]: [] });
    },
    addToPast: (v: Evaluation) => {
      const evaluationPast = past[evaluationId] || [];
      setPast({
        ...past,
        [evaluationId]: [...evaluationPast.slice(MAX_HISTORY_SIZE * -1), v],
      });
    },
    isFutureEmpty: (future[evaluationId] || []).length === 0,
    isPastEmpty: (past[evaluationId] || []).length === 0,
    setPast: (v: Array<Evaluation>) => setPast({ ...past, [evaluationId]: v }),
    setFuture: (v: Array<Evaluation>) =>
      setFuture({ ...future, [evaluationId]: v }),
    future: future[evaluationId] || [],
  };
}
